import { TCreateWorkflowTemplateParams } from '@commenda/types';
import { fetcher } from '@commenda/utils';
import { BASE_URL, readErrorMessage } from './helpers';

export async function createWorkflowTemplate(
  data: TCreateWorkflowTemplateParams
): Promise<{
  success: boolean;
  data?: { workflowTemplate: { id: string } };
  error?: string;
}> {
  try {
    const res = await fetcher(`${BASE_URL}`, {
      method: 'POST',
      body: data,
    });
    if (!res.ok)
      return {
        success: false,
        data: undefined,
        error: await readErrorMessage(res),
      };
    const responseData = (await res.json()) as {
      workflowTemplate: { id: string };
    };
    return {
      success: true,
      data: responseData,
    };
  } catch (err) {
    console.error(err);
    return { success: false, data: undefined };
  }
}
